import { useEffect, useState } from "react"
import Checkbox from "./Checkbox"

interface DropDownOption {
  title: string
  key: string
}

interface DropDownPickerProps {
  title?: string
  options?: DropDownOption[]
  selected?: string[]
  visible?: string[]
  onChange?: (selected: string[]) => void
}

const DropDownElement = (props: {
  option: DropDownOption & { checked: boolean }
  onChange: (checked: boolean) => void
}) => {
  const title = props.option.title.length > 20 ? props.option.title.slice(0, 20) + "..." : props.option.title

  return (
    <>
      <li>
        <Checkbox
          isChecked={props.option.checked}
          handleChange={(event) => props.onChange(event.target.checked)}
          label={title}
        ></Checkbox>
      </li>
    </>
  )
}

export const DropDownPicker = (props: DropDownPickerProps) => {
  const [expanded, setExpanded] = useState(false)
  const [extended, setExtended] = useState(false)

  const visibleOptions = props.visible
    ? props.options?.filter((option) => props.visible?.includes(option.key)) || []
    : props.options || []
  const extraOptions = props.visible
    ? props.options?.filter((option) => !props.visible?.includes(option.key)) || []
    : []

  const handleChange = (key: string, checked: boolean) => {
    if (!props.onChange) return
    const selected = props.selected || []

    if (checked) {
      if (!selected.includes(key)) {
        selected.push(key)
      }

      props.onChange(selected)
    } else {
      props.onChange(selected.filter((k) => k !== key))
    }
  }

  useEffect(() => {
    const listener = (evt: MouseEvent) => {
      console.log("evt.target", evt)
      if (evt.target instanceof HTMLElement && evt.target.closest(".name.dropdownpane-link")) {
        setExpanded((expanded) => !expanded)
      } else if (evt.target instanceof HTMLElement && !evt.target.closest(".dropdown-pane")) {
        setExpanded(false)
      }
    }
    window.addEventListener("click", listener)
    return () => window.removeEventListener("click", listener)
  }, [])

  return (
    <div className="select-menu dropdown-pane-container">
      <div className="name dropdownpane-link">
        <div>{props.title}</div>
        <div>
          <i className="icon-font tc-icon-arrow-drop-down"></i>
        </div>
      </div>
      {expanded && (
        <div className="dropdown-pane is-open dropdown">
          <ul>
            {visibleOptions
              .sort((a, b) => a.title.localeCompare(b.title))
              .map((option) => (
                <DropDownElement
                  key={option.key}
                  option={{ ...option, checked: props.selected?.includes(option.key) || false }}
                  onChange={(checked: boolean) => handleChange(option.key, checked)}
                />
              ))}
          </ul>
          <hr />
          {extended && (
            <ul>
              {extraOptions
                .sort((a, b) => a.title.localeCompare(b.title))
                .map((option) => (
                  <DropDownElement
                    key={option.key}
                    option={{ ...option, checked: props.selected?.includes(option.key) || false }}
                    onChange={(checked: boolean) => handleChange(option.key, checked)}
                  />
                ))}
            </ul>
          )}
          <button
            className="button link-primary"
            style={{
              position: "sticky",
              backgroundColor: "white",
              bottom: "-1rem",
              width: "100%"
            }}
            onClick={() => setExtended(!extended)}
          >
            {extended ? "Show Less" : "Show All"}
          </button>
        </div>
      )}
    </div>
  )
}
